import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  max-width: ${container('lg')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('xl3')};
  }
`;

export const StyledInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
  min-width: 18rem;
  align-self: center;
`;

export const StyledOutputs = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('xl4')};
  color: ${color('indigo_500')};
`;

export const StyledOutput = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};

  @media (min-width: ${screen('md')}) {
    gap: ${spacing('md')};
  }
`;

export const StyledLabel = styled.span`
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
  line-height: 1;
  font-size: ${fontSize('sm')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('md')};
  }
`;

export const StyledValue = styled.span`
  font-weight: ${fontWeight('semiBold')};
  font-size: ${fontSize('xl5')};
  font-family: ${fontFamily('display')};
  line-height: 1;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl7')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl9')};
  }
`;
